<section class="why-platform" aria-labelledby="why-platform-title">
  <div class="why-platform__inner">
    <p class="why-platform__eyebrow">Why this platform</p>

    <h2 id="why-platform-title" class="why-platform__title">
      Trusted AI benchmarking for the Indian healthcare context
    </h2>

    <p class="why-platform__text">
      Developing AI models for healthcare requires reliable benchmarks that reflect the populations
      they are intended to serve. BODH brings together clinical data, secure evaluation, and
      meaningful performance insight.
    </p>
  </div>

  <ul class="why-platform__cards">
    <li class="why-platform__card">
      <span class="why-platform__card-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <ellipse cx="12" cy="5.5" rx="7.5" ry="2.8" stroke="currentColor" stroke-width="1.8" />
          <path d="M4.5 5.5v13c0 1.55 3.36 2.8 7.5 2.8s7.5-1.25 7.5-2.8v-13" stroke="currentColor" stroke-width="1.8" />
          <path d="M4.5 12c0 1.55 3.36 2.8 7.5 2.8s7.5-1.25 7.5-2.8" stroke="currentColor" stroke-width="1.8" />
        </svg>
      </span>
      <h3 class="why-platform__card-title">Trusted benchmarking datasets</h3>
      <p class="why-platform__card-text">
        Evaluate against sovereign clinical data curated to support robust AI model evaluation.
      </p>
    </li>

    <li class="why-platform__card">
      <span class="why-platform__card-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2.5 4.5 5.4v6c0 4.6 3.2 8.8 7.5 10.1 4.3-1.3 7.5-5.5 7.5-10.1v-6L12 2.5Z"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linejoin="round"
          />
          <path
            d="m8.6 12 2.3 2.3 4.5-4.6"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <h3 class="why-platform__card-title">Secure model evaluation</h3>
      <p class="why-platform__card-text">
        Your model is evaluated within a confidential computing environment where it cannot be
        exposed.
      </p>
    </li>

    <li class="why-platform__card">
      <span class="why-platform__card-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M4 3.5v15.2c0 .9.7 1.6 1.6 1.6H21"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          />
          <path
            d="M8.5 16.5v-4M12.5 16.5v-7M16.5 16.5v-2.5"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          />
        </svg>
      </span>
      <h3 class="why-platform__card-title">Transparent evaluation</h3>
      <p class="why-platform__card-text">
        Receive detailed evaluation metrics designed for each benchmark task to understand model
        performance.
      </p>
    </li>

    <li class="why-platform__card">
      <span class="why-platform__card-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M6.5 21V5.5c0-1.1.9-2 2-2h7c1.1 0 2 .9 2 2V21"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linejoin="round"
          />
          <path d="M3 21h18M6.5 8H3.8v13M17.5 8h2.7v13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          <path d="M12 7.5v4M10 9.5h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          <path d="M10.5 21v-3.5a1.5 1.5 0 0 1 3 0V21" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
        </svg>
      </span>
      <h3 class="why-platform__card-title">Built for Indian healthcare AI</h3>
      <p class="why-platform__card-text">
        Evaluate models using benchmarking datasets that represent the Indian healthcare context.
      </p>
    </li>
  </ul>
</section>
